import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69fd088df6558f00143eb396_1782478776316_5318c043/ecami/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69fd088df6558f00143eb396_1782478776316_5318c043/ecami/src/components/AppLayout.tsx");
